var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-contrato-album"}},[_c('album',{attrs:{"reportesFisicos":_vm.getReportesFisicos,"contrato":_vm.getContrato,"modulo":_vm.modulo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }